import { CourseCompletion } from 'pages/corporate_reports/CourseCompletion';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'corporate_reports/course_completion',
  route: 'course_completion',
  label: 'Encerramento de Curso',
  parentName: 'corporate_reports',
  list: CourseCompletion,
  actions: ['list', 'export']
};

export default generateResources(resource);
